import React from 'react';
import './index.css';
import clsx from 'classnames';
import QueueAnim from 'rc-queue-anim';

const About = () => {
  const typeList = [
    {
      name: '客户导向',
      icon: '/images/type1.png',
    },
    {
      name: '检测质量',
      icon: '/images/type2.png',
    },
    {
      name: '智能协同',
      icon: '/images/type3.png',
    },
    {
      name: '精确管理',
      icon: '/images/type4.png',
    },
  ];

  return (
    <div className={clsx('about')}>
      <QueueAnim
        type={['left', 'right']}
        className={clsx('about-content')}
        duration={1000}
      >
        <div key='content'>
          <div className={clsx('about-title')}>关于上检</div>
          <div className={clsx('about-text')}>About Us</div>
          <div className={clsx('about-typeName')}>安全/科学/高效/优质</div>
          <div className={clsx('about-desc')}>
            {
              '本公司成立于2016年07月，专业从事安全工器具、施工机具、电力物资、电动工具、工程材料、光伏电站等产品的检测，是国家高新技术企业，具备CMA和CNAS第三方检测资质。公司业务遍布市政、通信、交通、建筑、石化、电力、新能源等重要行业。目前具有机械、电气、材料、工器具、高压、环境、高处防坠落和光伏等7大主要实验室。拥有直读光谱仪、燃烧箱、卧式拉力机、万能试验机、大电流试验系统、智能高压试验装置、红外成像仪、电能质量测试仪、步入式环境箱、氙灯老化箱、紫外老化箱、高处防坠落试验塔等数百台专业检测设备。公司为能源行业电力安全工器具及机具标委会委员单位，目前已牵头编制1份电力行业标准，主编和参与编制十余份行业和团体标准。'
            }
          </div>
          <QueueAnim
            className={clsx('about-type')}
            key='type'
            type={['left', 'right']}
          >
            {typeList?.map((item, index) => {
              return (
                <div key={index} className={clsx('about-type_item')}>
                  <div className={clsx('about-type_item-icon')}>
                    <img src={item.icon} alt={item.name} />
                  </div>
                  <div className={clsx('about-type_item-name')}>
                    {item.name}
                  </div>
                </div>
              );
            })}
          </QueueAnim>
        </div>
      </QueueAnim>
      <QueueAnim
        type={['right', 'left']}
        className={clsx('about-img')}
        duration={1000}
      >
        <img
          key='img'
          src={'/images/pageBlurb.png'}
          alt=''
          width={'100%'}
          height={'100%'}
        />
      </QueueAnim>
    </div>
  );
};

export default About;
